module.exports = __webpack_public_path__ + "static/img/6.21e9a3b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/sp/6.png
// module id = mWy5
// module chunks = 0